import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForSuspendContractForm } from "../../../components/create-application-for-suspend-contract";
import { useAFLRequest } from "../../../hooks";
const dataFallback = {};

export const SuspendContractEdit = withProcedureWraper(() => {
  const { data = dataFallback, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin tạm hoãn hợp đồng lao động" loading={isRequestFetching}>
      <CreateApplicationForSuspendContractForm data={data} />
    </ProcedureLayout>
  );
});
